import { render, staticRenderFns } from "./ReplaceData.vue?vue&type=template&id=cc0aec70&"
import script from "./ReplaceData.vue?vue&type=script&lang=js&"
export * from "./ReplaceData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports